module.exports = __webpack_public_path__ + "img/Trinity.80b52cbf.png";